import * as React from "react";
import { useField, useFormikContext } from "formik";
import { Box, Button, ButtonGroup, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

type YesOrNoFieldProps = {
  label: string;
  name: string;
};

export default function YesOrNoField({ label, name }: YesOrNoFieldProps) {
  const { t } = useTranslation();
  const { setFieldValue } = useFormikContext<"yes" | "no">();
  // eslint-disable-next-line
  const [field, _] = useField(name);
  const onChange = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    var bool = e.currentTarget.name === "yes";
    if (bool === field.value) return;
    setFieldValue(field.name, !field.value);
  };

  return (
    <Box>
      <Typography mb={1}>{label}</Typography>
      <ButtonGroup fullWidth>
        <Button
          name="no"
          sx={{ marginRight: 1 }}
          onClick={onChange}
          variant={!field.value ? "contained" : "outlined"}
        >
          {t("buttons.no")}
        </Button>
        <Button
          name="yes"
          sx={{ marginLeft: 1 }}
          onClick={onChange}
          variant={field.value ? "contained" : "outlined"}
        >
          {t("buttons.yes")}
        </Button>
      </ButtonGroup>
    </Box>
  );
}
